import script from "./AboutView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutView.vue?vue&type=script&lang=ts&setup=true"

import "./AboutView.vue?vue&type=style&index=0&id=4aa4e0d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa4e0d6"]])

export default __exports__